import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'mds-ui/environments/environment';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do'; // debug
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { catchError } from 'rxjs/operators';
import 'rxjs/Rx'; // use this line if you want to be lazy, otherwise:
import { Observable } from 'rxjs/Rx'
import { DateTimeFormatPipe } from '../pipes/date-time-format.pipe';
import { HandleError, HttpErrorHandler } from './http-error-handler.service';
import { PriestStatusTypeVO, PriestStatusTypeVORes } from '../model/PriestStatusTypeVO.model';


@Injectable()
export class PriestStatusTypeService {

   
    public priestStatusTypeVO:PriestStatusTypeVO;
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {

        this.handleError = httpErrorHandler.createHandleError('PriestStatusTypeService');
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };

    postPriestStatusType(priestStatusTypeVO: PriestStatusTypeVO): Observable<PriestStatusTypeVORes> {
        return this._http.post<any>(
            environment.postPriestStatusTypeUrl, priestStatusTypeVO, this.httpOptions) 
            .pipe(
                catchError(this.handleError('postPriestStatusType', []))
            );

    }

    getPriestStatusTypeById(id: number, userName: string): Observable<PriestStatusTypeVORes> {
        return this._http.get<any>(
            environment.getPriestStatusTypeByIdUrl + id + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getSeminarianOrdinationById', []))
            );
    }
  
    // getAllPriestStatusType(priestType: string): Observable<PriestStatusTypeVORes> {
    //     return this._http.get<any>(

    //         environment.postPriestStatusTypeUrl + "?priestType=" + priestType, this.httpOptions)
    //         .pipe(
    //             catchError(this.handleError('getAllPriestStatus', []))
    //         );
    // }


    
}